import React, { PureComponent, Fragment } from 'react';
import { Route, RouteProps } from 'react-router';

import Footer from '@components/footer';
import Header from '@components/header';
import { AppDataProps, withAppData } from 'client/contexts/app-data';

type Props = RouteProps & AppDataProps;

class LayoutRoute extends PureComponent<Props> {
    public renderRoute = (matchProps: any) => {
        const { component, appData } = this.props;
        const { desktopVersionAlways } = appData;
        const Component = (component as any);

        return (
            <Fragment>
                <Header key="header" />

                <div className="app-container" key="content">
                    <Component {...matchProps} />
                </div>

                <Footer
                    key="footer"
                    desktopVersionAlways={desktopVersionAlways}
                />
            </Fragment>
        );
    };

    public render() {
        const { component, ...rest } = this.props;

        return <Route {...rest} render={this.renderRoute} />;
    }
}

export default withAppData(LayoutRoute);
